import { SquareDashed } from "lucide-react";
import { resolveFrameworkIcon } from "./icon-registry";

/**
 * The one fallback for entity-type icons when a framework `iconKey` is missing or unknown.
 * Takes the entity type so a per-type fallback can be introduced in one place if we ever
 * want one; today every type falls back to the same neutral glyph.
 */
export function getEntityFallbackIcon(entityTypeKey: string): React.ElementType {
  void entityTypeKey;
  return SquareDashed;
}

export function resolveEntityDisplayIcon({
  entityTypeKey,
  iconKey,
}: {
  entityTypeKey: string;
  iconKey: string | null | undefined;
}): React.ElementType {
  return resolveFrameworkIcon(iconKey, getEntityFallbackIcon(entityTypeKey));
}
